import { SourceCrudApi } from "../../../client/EntityApi";
import { getOptionsFromEntities } from "../../../helpers/UtilHelper";
import SearchSelect from "../../common/SearchSelect";

const SourceSearchSelect = (props: any) => {
  const { optionValueKey, ...rest } = props;

  return (
    <SearchSelect
      {...rest}
      placeholder="Kaynak aramak için yazın.."
      searchAction={(searchValue, setOptions, setLoading) =>
        SourceCrudApi.getAll(true, 1, 10, searchValue)
          .then((response) => {
            setOptions(
              getOptionsFromEntities(
                response["hydra:member"],
                "name",
                optionValueKey ?? "@id"
              )
            );
          })
          .finally(() => setLoading(false))
      }
    />
  );
};

export default SourceSearchSelect;
